import { Navbar } from "../../components/navbar/Navbar"
import { Sidebar } from "../../components/sidebar/Sidebar"
import "./new.scss"
import { AddStudent } from "../../components/addnew/AddStudent"
import { AddCourse } from "../../components/addnew/AddCourse"
import { InstructorView } from "../../components/addnew/InstructorView"
import { AddTerm } from "../../components/addnew/AddTerm"
import { AddTermCourse } from "../../components/addnew/AddTermCourse"
import { AddFeedback } from "../../components/addnew/AddFeedback"
import { AddExaminerFeedback } from "../../components/addnew/AddExaminerFeedback"
import { AddStudentRequest } from "../../components/addnew/AddStudentRequest"
import { AddThesis } from "../../components/addnew/AddThesis"
import { AssignExaminer } from "../../components/addnew/AssignExaminer"
import { AssignCodeExaminer } from "../../components/addnew/AssignCodeExaminer"
import { ViewStudentFeedback } from "../../components/addnew/ViewStudentFeedback"
import { StudentSubmission } from "../../components/addnew/StudentSubmission"
import { ThesisMentor } from "../../components/addnew/ThesisMentor"
import { AssignTerm } from "../../components/addnew/AssignTerm"
import { AddAnnouncement } from "../../components/addnew/AddAnnouncement"
import { MonthlyEvaluation } from "../../components/addnew/MonthlyEvaluation"
import { ViewMonthlyEvaluation } from "../../components/addnew/ViewMonthlyEvaluation"
import { ThesisSubmission } from "../../components/addnew/ThesisSubmission"
import { StudentResources } from "../../components/addnew/StudentResources"
import { StudentResource } from "../../components/addnew/StudentResource"
import { LectureLinks } from "../../components/addnew/LectureLinks"
import { MailComm } from "../../components/addnew/MailComm"
import { MyCapstoneProject } from "../../components/addnew/MyCapstoneProject"
import { VivaSlot } from "../../components/addnew/VivaSlot"
import { AllVivaSlots } from "../../components/datatable/AllVivaSlots"
import { VivaAutoSchedule } from "../../components/datatable/VivaAutoSchedule"

export const New = ({type,studentId}) => {
  return (
    <div className="new">
    <Sidebar/>
    <div className="newContainer">
      <Navbar/>
      
      {type === "student" && <AddStudent/>}
      {type === "course" && <AddCourse/>}  
      {type === "instructor" && <InstructorView/>} 
      {type === "term" && <AddTerm/>}
      {type === "termCourse" && <AddTermCourse/>}
      {type === "feedback" && <AddFeedback/>}
      {type === "feedbacke" && <AddExaminerFeedback/>}
      {type === "studentrequest" && <AddStudentRequest/>}
      {type === "thesis" && <AddThesis/>}
      {type === "thesisdetails" && <ThesisSubmission/>}
      {type === "studentfeedback" && <ViewStudentFeedback/>}
      {type === "assignexaminer" && <AssignExaminer/>}
      {type === "assigncodeexaminer" && <AssignCodeExaminer/>}
      {type === "studentsubmission" && <StudentSubmission/>}
      {type === "viewfeedbacksexaminer" && <ThesisMentor/>}
      {type === "assignterms" && <AssignTerm/>}
      {type === "announcement" && <AddAnnouncement/>}
      {type === "monthlyevaluation" && <MonthlyEvaluation/>}
      {type === "viewMonthlyEvaluation" && <ViewMonthlyEvaluation/>}
      {type === "studentresources" && <StudentResources/>}
      {type === "studentresource" && <StudentResource/>}
      {type === "lecturelink" && <LectureLinks/>}
      {type === "mailcommunication" && <MailComm/>}
      {type === "mycapstoneproject" && <MyCapstoneProject/>}
      {type === "vivaslot" && <VivaSlot/>}
      {type === "allvivaslots" && <AllVivaSlots/>}
      {type === "vivaautoschedule" && <VivaAutoSchedule/>}

    </div>
    </div>
  )
}


export default New
